import ClassroomsLicenseReviewModal from "~/components/Classrooms/LicenseReview/Modal.vue";

export const useShowClassroomsLicenseReviewModal = () => {
  if (useAppUserDataStore().isLoggedIn != true) {
    return;
  }

  const { open, close } = useDialog({
    component: ClassroomsLicenseReviewModal,
    allowClose: false,
    showHeader: true,
    title: "Classroom License Review",
    props: {
      onClose: () => {
        close();
      },
    },
  });

  open();
};
